import type { ReactNode } from 'react';

/** Centred full-page message for a terminal state on the review route. */
export function ReviewMessage({
  children,
  tone = 'error',
}: {
  children: ReactNode;
  tone?: 'error' | 'muted';
}) {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-2 text-center">
      <p
        className={
          tone === 'error' ? 'text-sm font-semibold text-destructive' : 'text-sm text-globe-grey'
        }
      >
        {children}
      </p>
    </div>
  );
}
